import moment from "moment";

export const expired = date => moment(date).isBefore(moment());

export const formatStartEndTime = (startTime, endTime, date = false) => {
  if (date) {
    return (
      moment(startTime).format("M/D/YYYY @ h:mma") +
      "-" +
      moment(endTime).format("h:mma")
    );
  } else {
    return (
      moment(startTime).format("h:mma") + "-" + moment(endTime).format("h:mma")
    );
  }
};

export const dateWithDayOfWeek = (date, includeTime = false) =>
  moment(date).format(`ddd, MMM D, YYYY ${includeTime ? " @ h:mma" : ""}`);
